<fui-column [formGroup]="formGroup">
    <wbo-single-select-edit-control [value]="getAvailabilityValue()"
                                    class="availability-column-select"
                                    [ngClass]="{'set': this.productCount != undefined}"
                                    [allowClearSelectionOption]="false"
                                    (onSelect)="updateAvailability($event.value)"
                                    label="wbo.web-ordering-item-availability.field.manageItemAvailability.availability.label"
                                    placeholder="wbo.web-ordering-item-availability.field.manageItemAvailability.availability.placeholder">
        <wbo-select-options>
            <wbo-select-option [value]="ItemAvailability.AVAILABLE"
                               [label]="productCount > 0 ? 'wbo.web-ordering-item-availability.option.availability.availableCountDown' : 'wbo.web-ordering-item-availability.option.availability.available'"
                               [labelParams]="{'countdown': productCount}">
            </wbo-select-option>
            <wbo-select-option [value]="ItemAvailability.SOLD_OUT"
                               label="wbo.web-ordering-item-availability.option.availability.soldOut">
            </wbo-select-option>
            <wbo-select-option [value]="ItemAvailability.SOLD_OUT_TODAY"
                               label="wbo.web-ordering-item-availability.option.availability.soldOutToday">
            </wbo-select-option>
            <wbo-select-option [value]="ItemAvailability.NOT_SOLD"
                               label="wbo.web-ordering-item-availability.option.availability.notSold">
            </wbo-select-option>
        </wbo-select-options>
    </wbo-single-select-edit-control>
    <ng-container *ngIf="getAvailabilityValue() !== ItemAvailability.NOT_SOLD">
        <div class="spinner">
            <fui-mark-button class="spinner-button"
                             (click)="decrementProductCount()">
                <fui-icon icon="remove" height="20" width="20"></fui-icon>
            </fui-mark-button>
            <wbo-numeric-edit-control class="spinner-value"
                                      [(value)]="productCount"
                                      [decimals]="0" [showClear]="true"
                                      label="wbo.web-ordering-item-availability.field.manageItemAvailability.productCount.label"
                                      placeholder="wbo.web-ordering-item-availability.field.manageItemAvailability.productCount.placeholder">
            </wbo-numeric-edit-control>
            <fui-mark-button class="spinner-button"
                             (click)="incrementProductCount()">
                <fui-icon icon="plus" height="20" width="20"></fui-icon>
            </fui-mark-button>
        </div>
        <wbo-checkbox-edit-control class="resetAtStartOfDay"
                                   [(value)]="resetAtStartOfDay"
                                   label="wbo.web-ordering-item-availability.field.manageItemAvailability.resetAtStartOfDay.label">
        </wbo-checkbox-edit-control>
        <wbo-numeric-edit-control *ngIf="resetAtStartOfDay"
                                  [(value)]="restockLevel"
                                  [decimals]="0" [showClear]="true"
                                  label="wbo.web-ordering-item-availability.field.manageItemAvailability.restockLevel.label"
                                  placeholder="wbo.web-ordering-item-availability.field.manageItemAvailability.restockLevel.placeholder">
        </wbo-numeric-edit-control>
    </ng-container>
</fui-column>
